import { graphql } from 'relay-runtime';

export const getWeeklyGoalIndicator = graphql`
  query WeeklyGoalIndicatorQuery($studentId: ID!, $fromDate: DateTime!, $toDate: DateTime!) {
    studentWeeklyGoalIndicator(studentId: $studentId, fromDate: $fromDate, toDate: $toDate) {
      code
      name
    }
  }
`;
